import React from "react";
import NewsletterInline from "./NewsletterInline";

export const BrandBand = () => {
  return (
    <section className="section" data-testid="brand-band" style={{ backgroundColor: "var(--sand)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 items-end">
        <div className="md:col-span-7 md:col-start-1">
          <div className="overline">Stay informed</div>
          <h2 className="font-serif-editorial tight-track mt-6" style={{ fontSize: "clamp(2.4rem, 4.6vw, 4rem)", lineHeight: 1.05 }}>
            Knowledge is the first step to healing.
          </h2>
          <p className="mt-8 text-lg" style={{ maxWidth: "34rem" }}>
            A weekly editorial from the Institute — new research, considered recipes, and practical tools. No noise. No sales pitch. Just the essentials.
          </p>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <NewsletterInline testid="brand-band-newsletter" />
          <div className="mt-6 text-xs opacity-70" style={{ letterSpacing: "0.08em" }}>
            Free. Unsubscribe with one click.
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandBand;
